import React from 'react';
import { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import "./userData.css"
import ApiService from '../../../services/ApiService';
import CustomInputValue from '../../../components/Elements/inputWithValue/customInputValue';
import CustomInput from '../../../components/Elements/input/customInput';
import ChooseUserOption from '../../chooseUserBuy/chooseUser/chooseUserOption/chooseUserOption';
import CustomButtons from '../../../components/Elements/Buttons/customButton';
import CustomTittle from '../../../components/Elements/customTittle/customTittle';
import CourseDetail from '../../coursDetail/courseDetail';
import CustomSelect from '../../../components/Elements/Select/CustomSelect';
const UserData = (props) => {
    const camp = JSON.parse( localStorage.getItem("campHeadingFull"))
    const styles = camp?.courseDanceStyle?.split(",")
    const ageCategory = camp?.courseAgeRanges?.split(",")
    const diets = ["Standart", "Wegańska", "Inna"];
    const apiService = ApiService.getInstance();   
    const [difrentDiet, setDifrenDiet] = useState(false);
    const [validation, setValidation] = useState({
        diet:true,
        name:true,
        lastName:true,
        eMail:true,
        phone:true,
        pesel:true,
        bDay:true,
        street:true,
        flat:true,
        building:true,
        city:true,
        postalCode:true,
        courseAgeRangesDVID:true,
        courseDanceStyleDVID:true,
        school:true,
        departure:true,
        discription:true,
        });
    let userId;
  
    if(props.parcipient != undefined){
        userId = props.parcipient
    }else{
        userId = props.option.usersID
    }
   function PeselDecode(pesel) {
        
    var rok = parseInt(pesel.substring(0, 2), 10);
    var miesiac = parseInt(pesel.substring(2, 4), 10);
    var dzien = parseInt(pesel.substring(4, 6), 10);

    if (miesiac > 80) {
        rok = rok + 1800;
        miesiac = miesiac - 80;
    } else if (miesiac > 60) {
        rok = rok + 2200;
        miesiac = miesiac - 60;
    } else if (miesiac > 40) {
        rok = rok + 2100;
        miesiac = miesiac - 40;
    } else if (miesiac > 20) {
        rok = rok + 2000;
        miesiac = miesiac - 20;
    } else {
        rok += 1900;
    }
    // Daty sa ok. Teraz ustawiamy.
    if(miesiac < 10){
        miesiac = "0" + miesiac 
    }
    if(dzien < 10){
        dzien = "0" + dzien
    }
    var urodzony = rok + '-' + miesiac + '-' + dzien;

    if(urodzony != null){
        
    document.getElementById("calendary").value = urodzony}
    return urodzony
   

}
function showCalendary(e){
      
    document.getElementById("calendary").showPicker();
}
// const payload = {
//     keyController: 'getAllPaymets',
//     usersID: userId,
//     current_LocalizationsID: '0',
// };

// const methodProxySend = () => {
//     apiService.apiPost('CalculateProductForUser', payload, (response) => {
//         if (response.success) {
//             console.log(response.data.responseBody.body);
//             // setRes(response.data.responseBody.body);
//         }
//     });
// };
useEffect(()=>{
    //methodProxySend()
    props.setUserData({
        ...props.userData,
        ...{ courseDanceStyleDVID: camp.courseDanceStyleDVID, courseAgeRangesDVID:camp.courseAgeRangesDVID },
    });
    }

,[])






function nextStep(){
    
    if(props.userData.departure != ""&&props.userData.postalCode != ""&&props.userData.courseAgeRangesDVID != ""&&props.userData.courseDanceStyleDVID != ""&& props.userData.street != ""&&props.userData.building != ""&&props.userData.city != ""&&props.userData.diet != " "&&props.userData.diet != ""&&props.userData.name != ""&&props.userData.lastName != ""&&props.userData.eMail != "" &&props.userData.phone != ""&&props.userData.pesel != ""&&props.userData.bDay != ""){
    props.next()}
    
    else{
       
setValidation(
    {
        diet:props.userData.diet != ""&&props.userData.diet != " ",
        name:props.userData.name != "",
        lastName:props.userData.lastName != "",
        eMail:props.userData.eMail != "",
        phone:props.userData.phone != "",
        pesel:props.userData.pesel != "",
        bDay:props.userData.bDay != "",
        street:props.userData.street != "",

        building:props.userData.building != "",
        city:props.userData.city != "",
        postalCode:props.userData.postalCode != "",
        courseAgeRangesDVID:props.userData.courseAgeRangesDVID != "",
        courseDanceStyleDVID:props.userData.courseDanceStyleDVID != "",

        departure:props.userData.departure != "",
    
        }
)
    }
}

    return <> 
    
    <div className='wrraper'>
    
    <div style={{height: "fit-content"}}>
    <CustomTittle>Wprowadź dane uczestnika obozu, aby wziąć udział</CustomTittle>
    <div style={{marginTop: "20px"}}>
        <CustomInputValue  value={props.userData.name} size="big" title={"Imię"}></CustomInputValue>
        <CustomInputValue  value={props.userData.lastName} size="big" title={"Nazwisko"}></CustomInputValue>
        <CustomInputValue  value={props.userData.eMail} size="big" title={"E-mail"}></CustomInputValue>
        <CustomInputValue  value={props.userData.phone} size="big" title={"Nr. telefonu"}></CustomInputValue>
    </div>
        <CustomInput
                id="pesel"
                value={props.userData.pesel}
                validation={validation.pesel}
                showCalendary={(e) => {
                    
                }}
                isRequied={true}
                title="Pesel"
                onChangeInput={(e) => {  
                    let value = e.replaceAll(' ', '');
                                  
                    if (/^\d+$/.test(value) ) {
                        let weight = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
                        let sum = 0;
                        let controlNumber = parseInt(value.substring(10, 11));
                    
                        for (let i = 0; i < weight.length; i++) {
                            sum += (parseInt(value.substring(i, i + 1)) * weight[i]);
                        }
                        sum = sum % 10;
                        let isCorrect =  (10 - sum) % 10 === controlNumber;
                    
                    
                    if(isCorrect){
                        let bd = PeselDecode(e)
                        props.setUserData({
                            ...props.userData,
                            ...{ pesel: e, bDay: bd },
                        })
                    }else{
                        props.setUserData({
                            ...props.userData,
                            ...{ pesel: e, bDay: "" },
                        })
                        if(validation.street){
                            setValidation({...validation,...{pesel: true}})
                        }
                    };
                }else if(value == ""){
                    props.setUserData({
                        ...props.userData,
                        ...{ pesel: "", bDay: "" },
                    })
                }
                }}
        ></CustomInput>
         <CustomInput
                                    id="calendary"
                                    value={props.userData.bDay}
                                    icon={<svg onClick={showCalendary} width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M5.06847 13.9347H4.99777C4.52668 13.9347 4.14983 14.3115 4.14983 14.7826V14.8768C4.14983 15.3479 4.52668 15.7248 4.99777 15.7248H5.06847C5.53956 15.7248 5.91641 15.3479 5.91641 14.8768V14.7826C5.91641 14.3115 5.53956 13.9347 5.06847 13.9347Z" fill="#CC0033"/>
                                    <path d="M8.50746 13.9347H8.43677C7.96567 13.9347 7.58882 14.3115 7.58882 14.7826V14.8768C7.58882 15.3479 7.96567 15.7248 8.43677 15.7248H8.50746C8.97855 15.7248 9.35541 15.3479 9.35541 14.8768V14.7826C9.35541 14.3115 8.97855 13.9347 8.50746 13.9347Z" fill="#CC0033"/>
                                    <path d="M11.97 13.9347H11.8758C11.4047 13.9347 11.0278 14.3115 11.0278 14.7826V14.8768C11.0278 15.3479 11.4047 15.7248 11.8758 15.7248H11.97C12.4411 15.7248 12.8179 15.3479 12.8179 14.8768L12.818 14.7826C12.818 14.3115 12.4411 13.9347 11.97 13.9347Z" fill="#CC0033"/>
                                    <path d="M5.06847 10.4486H4.99777C4.52668 10.4486 4.14983 10.8254 4.14983 11.2965V11.3907C4.14983 11.8618 4.52668 12.2387 4.99777 12.2387H5.06847C5.53956 12.2387 5.91641 11.8618 5.91641 11.3907V11.2965C5.91641 10.8254 5.53956 10.4486 5.06847 10.4486Z" fill="#CC0033"/>
                                    <path d="M8.50746 10.4486H8.43677C7.96567 10.4486 7.58882 10.8254 7.58882 11.2965V11.3907C7.58882 11.8618 7.96567 12.2387 8.43677 12.2387H8.50746C8.97855 12.2387 9.35541 11.8618 9.35541 11.3907V11.2965C9.35541 10.8254 8.97855 10.4486 8.50746 10.4486Z" fill="#CC0033"/>
                                    <path d="M11.97 10.4486H11.8758C11.4047 10.4486 11.0278 10.8254 11.0278 11.2965V11.3907C11.0278 11.8618 11.4047 12.2387 11.8758 12.2387H11.97C12.4411 12.2387 12.8179 11.8618 12.8179 11.3907V11.2965C12.818 10.8254 12.4411 10.4486 11.97 10.4486Z" fill="#CC0033"/>
                                    <path d="M15.4089 13.9347H15.3147C14.8436 13.9347 14.4668 14.3115 14.4668 14.7826V14.8768C14.4668 15.3479 14.8436 15.7248 15.3147 15.7248H15.4089C15.88 15.7248 16.2569 15.3479 16.2569 14.8768V14.7826C16.2804 14.3115 15.88 13.9347 15.4089 13.9347Z" fill="#CC0033"/>
                                    <path d="M18.8714 13.9347H18.7772C18.3061 13.9347 17.9293 14.3115 17.9293 14.7826V14.8768C17.9293 15.3479 18.3061 15.7248 18.7772 15.7248H18.8714C19.3425 15.7248 19.7194 15.3479 19.7194 14.8768V14.7826C19.7194 14.3115 19.3425 13.9347 18.8714 13.9347Z" fill="#CC0033"/>
                                    <path d="M15.4089 10.4486H15.3147C14.8436 10.4486 14.4668 10.8254 14.4668 11.2965V11.3907C14.4668 11.8618 14.8436 12.2387 15.3147 12.2387H15.4089C15.88 12.2387 16.2569 11.8618 16.2569 11.3907V11.2965C16.2804 10.8254 15.88 10.4486 15.4089 10.4486Z" fill="#CC0033"/>
                                    <path d="M18.8714 10.4486H18.7772C18.3061 10.4486 17.9293 10.8254 17.9293 11.2965V11.3907C17.9293 11.8618 18.3061 12.2387 18.7772 12.2387H18.8714C19.3425 12.2387 19.7194 11.8618 19.7194 11.3907V11.2965C19.7194 10.8254 19.3425 10.4486 18.8714 10.4486Z" fill="#CC0033"/>
                                    <path d="M5.06847 17.3972H4.99777C4.52668 17.3972 4.14983 17.774 4.14983 18.2451V18.3393C4.14983 18.8104 4.52668 19.1873 4.99777 19.1873H5.06847C5.53956 19.1873 5.91641 18.8104 5.91641 18.3393V18.2451C5.91641 17.7976 5.53956 17.3972 5.06847 17.3972Z" fill="#CC0033"/>
                                    <path d="M8.50746 17.3972H8.43677C7.96567 17.3972 7.58882 17.774 7.58882 18.2451V18.3393C7.58882 18.8104 7.96567 19.1873 8.43677 19.1873H8.50746C8.97855 19.1873 9.35541 18.8104 9.35541 18.3393V18.2451C9.35541 17.7976 8.97855 17.3972 8.50746 17.3972Z" fill="#CC0033"/>
                                    <path d="M11.97 17.3972H11.8758C11.4047 17.3972 11.0278 17.774 11.0278 18.2451V18.3393C11.0278 18.8104 11.4047 19.1873 11.8758 19.1873H11.97C12.4411 19.1873 12.8179 18.8104 12.8179 18.3393V18.2451C12.818 17.7976 12.4411 17.3972 11.97 17.3972Z" fill="#CC0033"/>
                                    <path d="M15.4089 17.3972H15.3147C14.8436 17.3972 14.4668 17.774 14.4668 18.2451V18.3393C14.4668 18.8104 14.8436 19.1873 15.3147 19.1873H15.4089C15.88 19.1873 16.2569 18.8104 16.2569 18.3393V18.2451C16.2804 17.7976 15.88 17.3972 15.4089 17.3972Z" fill="#CC0033"/>
                                    <path d="M18.8714 17.3972H18.7772C18.3061 17.3972 17.9293 17.774 17.9293 18.2451V18.3393C17.9293 18.8104 18.3061 19.1873 18.7772 19.1873H18.8714C19.3425 19.1873 19.7194 18.8104 19.7194 18.3393V18.2451C19.7194 17.7976 19.3425 17.3972 18.8714 17.3972Z" fill="#CC0033"/>
                                    <path d="M23.1113 7.69266V5.78476C23.1113 4.32441 21.9336 3.14664 20.4967 3.14664H19.107V2.32224C19.107 1.30935 18.2826 0.48494 17.2697 0.48494C16.2568 0.48494 15.4324 1.30935 15.4324 2.32224V3.14664L8.46025 3.14657V2.32216C8.46025 1.30927 7.63584 0.484863 6.62296 0.484863C5.61007 0.484863 4.78566 1.30927 4.78566 2.32216V3.14657H3.39592C1.93558 3.14657 0.757812 4.3243 0.757812 5.78468V19.8703C0.757812 21.3071 1.93554 22.4849 3.39592 22.4849H20.5201C21.9569 22.4849 23.1346 21.3071 23.1346 19.8703L23.1113 7.69266ZM16.516 2.32222C16.516 1.92183 16.8458 1.59204 17.2462 1.59204C17.6466 1.59204 17.9764 1.92183 17.9764 2.32222V4.06527C17.9764 4.46566 17.6466 4.79544 17.2462 4.79544C16.8458 4.79544 16.516 4.46566 16.516 4.06527V2.32222ZM5.86935 2.32222C5.86935 1.92183 6.19913 1.59204 6.59952 1.59204C6.99991 1.59204 7.32969 1.92183 7.32969 2.32222V4.06527C7.32969 4.46566 6.99991 4.79544 6.59952 4.79544C6.19913 4.79544 5.86935 4.46566 5.86935 4.06527V2.32222ZM3.37256 4.25373H4.78584C4.88007 5.17238 5.65732 5.90255 6.62313 5.90255C7.56532 5.90255 8.34266 5.17238 8.4368 4.25373H15.4325C15.5267 5.17238 16.304 5.90255 17.2462 5.90255C18.1883 5.90255 18.9657 5.17238 19.0598 4.25373H20.4731C21.2975 4.25373 21.9806 4.93683 21.9806 5.78477V7.15098L1.84146 7.1509V5.7847C1.84146 4.93675 2.52462 4.25373 3.37256 4.25373ZM20.4967 21.3779H3.37256C2.52462 21.3779 1.84152 20.6948 1.84152 19.8704V8.23443H22.0042V19.8704C22.0043 20.6948 21.3211 21.3779 20.4967 21.3779Z" fill="#CC0033"/>
                                    </svg>
                                    }
                                    validation={validation.bDay}
                                    showCalendary={(e) => {
                                        e.target.showPicker();
                                        
                                    }}
                                    pattern="dd.mm.rrrr"
                                    type="date"
                                    isRequied={true}
                                    onChangeInput={(e) => {
                                       
                                        let value = e.trim();
                                       
                                        if (/^[0-9]{4}-[0-9]{2}-[0-9]{2}/.test(value)) {
                                            props.setUserData({
                                                ...props.userData,
                                                ...{  bDay: value },
                                            })
                                        } 
                                    }}
                                    title="Data urodzenia"
        ></CustomInput>
        <div className="row_input">
            <CustomInput
                value={props.userData.street }
                validation={validation.street }
                showCalendary={() => {
                  
                }}
                size="small"
                isRequied={true}
                title="Ulica"
                onChangeInput={(e) => {
                    let value = e.trim();
                    if(!validation.street){
                        setValidation({...validation,...{street: true}})
                    }
                        
                        props.setUserData({
                            ...props.userData,
                            ...{ street: value },
                        });
                        
                }}
            ></CustomInput>
            <CustomInput
                validation={validation.building}
                showCalendary={() => {
                   
                }}
                value={props.userData.flat != ""?props.userData.building +"/"+props.userData.flat:props.userData.building }
                size="small"
                pattern="/"
                isRequied={true}
                title="Nr domu/mieszkania"
                onChangeInput={(e) => {
                 
                    
                    let building = e.split('/')[0];
                    let flat = e.split('/')[1] == undefined ? '' : e.split('/')[1];
                    let value = building;
                    if(e.includes("/")&&props.userData.flat == ""){
                        flat = " "
                    }else{
                        flat.replace(/\s/g, '')
                    }
                    if(!validation.building){
                        setValidation({...validation,...{building: true}})
                    }
                        props.setUserData({
                            ...props.userData,
                            ...{ building: value, flat: flat },
                        });
                   
                }}
            ></CustomInput> 
        </div>
        <div className="row_input">
            <CustomInput
                validation={validation.city}
                value={props.userData.city}
                showCalendary={() => {
                  
                }}
                size="small"
                isRequied={true}
                title="Miejscowość"
                onChangeInput={(e) => {
                    let value = e.trim();
                    if(!validation.city){
                        setValidation({...validation,...{city: true}})
                    }
                        
                        props.setUserData({
                            ...props.userData,
                            ...{ city: value },
                        });
            
                }}
            ></CustomInput>
            <CustomInput
                validation={validation.postalCode}
                showCalendary={() => {
                   
                }}
                size="small"
                value={props.userData.postalCode}
                isRequied={true}
                title="Kod pocztowy"
                onChangeInput={(e) => {
                    let value = e.trim();
                    if(value.length < 7){
                    props.setUserData({
                        ...props.userData,
                        ...{ postalCode: value },
                    });
                    
                    if (/^[0-9]{2}-[0-9]{3}/.test(value)) {
                        if(!validation.postalCode){
                            setValidation({...validation,...{postalCode: true}})
                        }
                       
                    } else {
                        setValidation({...validation,...{postalCode: false}})
                    }}
                        
                  
                }}
            ></CustomInput> 
        </div>
        <CustomSelect
        title={"Kategoria wiekowa"}
        onChangeInput={(e)=>{console.log(e)}}
        optionLabels={ageCategory}
        isRequied={true}
       ></CustomSelect>
        <CustomSelect
        title={"Preferowany styl tańca"}
        onChangeInput={(e)=>{console.log(e)}}
        optionLabels={styles}
        isRequied={true}
       ></CustomSelect>
        

        
        <div className="styleList">
        <p className='forWho'>Wybierz diete</p>
        {diets.map((diet)=>{
            return <ChooseUserOption
                isChekcked={diet == "Inna"?difrentDiet:props.userData.diet == diet}
                onCheck={(e) => {
                    if(diet == "Inna"){
                        props.setUserData({
                            ...props.userData,
                            ...{ diet: " "},
                            });
                        setDifrenDiet(true)}else{
                            if(!validation.diet){
                                setValidation({...validation,...{diet: false}})
                            }
                    props.setUserData({
                        ...props.userData,
                        ...{ diet: diet},
                        });
                        setDifrenDiet(false)}
                    }}
                label={diet}
            ></ChooseUserOption>
        })}
      
        {!validation.diet&&!difrentDiet?<p className="errorMsg">Wybierz diete</p>:""}
        {difrentDiet?<CustomInput
                validation={validation.diet}
                showCalendary={() => {
                   
                }}
                size="small"
            
                isRequied={true}
                title="Inna dieta"
                pattern={"wpisz jaka"}
                onChangeInput={(e) => {
                    if(!validation.diet){
                        setValidation({...validation,...{diet: true}})
                    }
                    
                    props.setUserData({
                            ...props.userData,
                            ...{ diet: e },
                        });
                   
                }}
            ></CustomInput>:""}
        </div>
        <div className="inputComments">
        <CustomInput
                
                showCalendary={() => {
                   
                }}
                size="big"
                isHeight={true}
                
                title="Prośby/dodatkowe informacje"
                value={props.userData.discription}
                onChangeInput={(e) => {
                    
                    
                    props.setUserData({
                            ...props.userData,
                            ...{ discription: e },
                        });
                   
                }}
            ></CustomInput></div>  
            <div class="MarginTop20">
        <CustomButtons clickFunction={nextStep}  classButton="solid" size="big">ZATWIERDŹ</CustomButtons>
    </div></div>          
    <div className='columDetials'>

<div className='columDetials_wrapper'>
             <CustomTittle>Szczegóły zamówienia  </CustomTittle>
             <CourseDetail wrapNavigator={props.wrapNavigator}  setWrapNavigator={props.setWrapNavigator} setHeader={(e)=>{props.setHeader(e)}} header={props.header}></CourseDetail>
 </div>
</div>
</div>
</>;
    }

export default UserData;
